<!--  -->
<template>
  <div class="contaniner">
    <banner :type="type" :poster="poster" :currenTag="currentTag"></banner>
    <div class="news-content-box">
      <div class="top-wrapper">
        <div class="head-title">{{ title }}</div>
      </div>
      <div class="main-wrapper" v-html="richTextContent"></div>
    </div>
    <msg-box></msg-box>
    <top-arrow></top-arrow>
    <moni-footer></moni-footer>
  </div>
</template>

<script>
import banner from "../../components/banner/banner";
import moniFooter from "../../components/moniFooter/moniFooter";
import share from "../../components/share/share";
import msgBox from "../../components/msgBox/msgBox";
import topArrow from "../../components/topArrow/topArrow";
import http from "../../api/http.js";
import apiUrl from "../../api/apiUrl.js";
import util from "../../api/util.js";
import "jquery";

export default {
  name: "announcePage",
  data() {
    return {
      type: "poster",
      poster: require("../../assets/images/banner5.png"),
      currentTag: -1,
      title: "",
      richTextContent: "",
      announceId: ""
    };
  },

  props: [],

  mounted() {},

  watch: {
    $route: function(to, from) {
      if (to.name == "AnnouncePage") {
        console.log("sss");
        $("html,body").animate({ scrollTop: 0 }, 500);
        this.fetchNewsDetailInfo();
      }
    }
  },

  components: {
    banner,
    moniFooter,
    share,
    msgBox,
    topArrow
  },

  computed: {},

  created() {
    $("html,body").animate({ scrollTop: 0 }, 500);
    this.fetchNewsDetailInfo();
  },

  methods: {
    fetchNewsDetailInfo() {
      const id = this.$route.query.announceId;
      let url = apiUrl.announcementInfo + "/" + id;
      http.getInAppPath(url).then(response => {
        if (response.code == 0) {
          if (response.data) {
            const data = response.data;
            this.title = data.title;
            this.richTextContent = data.richTextContent;
          }
        }
      });
    }
  }
};
</script>

<!-- 富文本去除scoped-->
<style lang="scss">
.contaniner {
  .news-content-box {
    width: 100%;
    padding: 80px 350px 100px 350px;
    box-sizing: border-box;
    font-size: 20px;
    text-align: left;
    .top-wrapper {
      border-bottom: #ccc solid 2px;
      padding-bottom: 29px;
      .head-title {
        color: #333;
        font-size: 30px;
        line-height: 42px;
      }
      .head-desc {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;
        color: #999;
        font-size: 16px;
        line-height: 22px;
        .detail-desc {
          display: flex;
          display: inline-block\0;
          div {
            display: inline-block\0;
            margin-right: 40px;
          }
        }
        .share-item {
          display: inline-block\0;
          float: right\0;
          vertical-align: middle\0;
        }
      }
    }
    .main-wrapper {
      font-size: 18px;
      line-height: 40px;
      p {
        margin-top: 15px;
        text-indent: 2em;
      }
      padding: 30px 0;
      border-bottom: #ccc dashed 1px;
    }
    .nav-wrapper {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      font-size: 18px;
      line-height: 25px;
      color: #fbabc7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/announcePage/announcePage.vue